import React, { useState } from 'react';
import { useTransition, animated } from 'react-spring'

/**
 * This is a simple fade-in and fade-out animated
 * <li> component
 */
export default function FadeInFadeOutLi(props) {
    const [show, set] = useState(true)
    const {children} = props
    const transitions = useTransition(show, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    })
    return transitions.map(({ item, key, props }) =>
        item && <animated.li className="list-group-item clearfix" key={key} style={props}>
            <span>{children}</span>
        </animated.li>
    )
}